<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="css">
@import './assets/css/general_style.css';
@import 'bulma/css/bulma.css';
</style>

<style lang="scss">
@charset 'UTF-8';
@import './assets/css/general_sass_style.sass';

@import './assets/scss/core.scss';
@import 'bulma/bulma.sass';

@import 'buefy/dist/buefy.css';
@import './assets/css/margin_shortcuts.css';
@import url('https://use.fontawesome.com/releases/v5.7.0/css/all.css');
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,700');
@import url('https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css');

@import 'wallop/css/wallop.css';
</style>

<script>
export default {
  name: 'App',
};
</script>
